
const MASK_TXT_DEFAULT_MAP = {
    CN: '亚洲屡获殊荣的投资平台',
    HK: '亞洲屢獲殊榮的投資平台',
    EN: 'Invest with One Super App'
}
const ONE_LEVEL_TITLE_DEFAULT_MAP = {
    CN: '灵活投资全球市场创造吸引力',
    HK: '靈活投資全球市場創造吸引力',
    EN: 'Invest with One Super App'
}
const TWO_LEVEL_TITLE_DEFAULT_MAP = {
    CN: '在低利率的市场环境下，投资者比较难在公募债券市场上获得有吸引力的回报。',
    HK: '在低利率的市場環境下，投資者比較難在公募債券市場上獲得有吸引力的回報。',
    EN: 'Trade Blue-Chip Stocks in US, HK and SG Markets'
}

const MASK_TXT_FONT_SIZE_MAP = {
    CN: '.68rem',
    HK: '.68rem',
    EN: '.7rem',
};
const ONE_LEVEL_TITLE_FONT_SIZE_MAP = {
    CN: '.74rem',
    HK: '.74rem',
    EN: '.74rem',
};
const TWO_LEVEL_TITLE_FONT_SIZE_MAP = {
    CN: '.24rem',
    HK: '.24rem',
    EN: '.24rem',
};
const MASK_TXT_FONT_FAMILY_MAP = {
    CN: 'FZLanTingHeiS-DB1-GBK',
    HK: 'FZLanTingHeiS-DB1-GBK',
    EN: 'brRegular',
};
const ONE_LEVEL_TITLE_FONT_FAMILY_MAP = {
    CN: 'FZLanTingHeiS-DB1-GBK',
    HK: 'FZLanTingHeiS-DB1-GBK',
    EN: 'brRegular',
};
const TWO_LEVEL_TITLE_FONT_FAMILY_MAP = {
    CN: 'FZLanTingHei-R-GBK',
    HK: 'FZLanTingHei-R-GBK',
    EN: 'brRegular',
};
const MASK_TXT_COLOR_MAP = {
    CN: '#FFFFFF',
    HK: '#FFFFFF',
    EN: '#FFFFFF',
};
const ONE_LEVEL_TITLE_COLOR_MAP = {
    CN: '#FFFFFF',
    HK: '#FFFFFF',
    EN: '#FFFFFF',
};
const TWO_LEVEL_TITLE_COLOR_MAP = {
    CN: '#FFFFFF',
    HK: '#FFFFFF',
    EN: '#FFFFFF',
};
const MASK_TXT_LINE_HEIGHT_MAP = {
    CN: '.86rem',
    HK: '.86rem',
    EN: '.8rem',
};
const ONE_LEVEL_TITLE_LINE_HEIGHT_MAP = {
    CN: '.8rem',
    HK: '.8rem',
    EN: '.8rem',
};
const TWO_LEVEL_TITLE_LINE_HEIGHT_MAP = {
    CN: '.34rem',
    HK: '.34rem',
    EN: '.34rem',
};

const MASK_TXT = '<div><p style="line-height:.8rem"><span style="font-size:.7rem;font-family:brBold;color:#FFFFFF;">Smart trading anytime, anywhere</span></p></div>';

const UPLOAD_URL_MAP = {
    HK: 'http://cloud.crm.com/',
    OTHER: 'http://cloud-mm.crm.com/',
}

export {
    MASK_TXT,

    MASK_TXT_DEFAULT_MAP,
    ONE_LEVEL_TITLE_DEFAULT_MAP,
    TWO_LEVEL_TITLE_DEFAULT_MAP,
    MASK_TXT_FONT_SIZE_MAP,
    ONE_LEVEL_TITLE_FONT_SIZE_MAP,
    TWO_LEVEL_TITLE_FONT_SIZE_MAP,
    MASK_TXT_FONT_FAMILY_MAP,
    ONE_LEVEL_TITLE_FONT_FAMILY_MAP,
    TWO_LEVEL_TITLE_FONT_FAMILY_MAP,
    MASK_TXT_COLOR_MAP,
    ONE_LEVEL_TITLE_COLOR_MAP,
    TWO_LEVEL_TITLE_COLOR_MAP,
    MASK_TXT_LINE_HEIGHT_MAP,
    ONE_LEVEL_TITLE_LINE_HEIGHT_MAP,
    TWO_LEVEL_TITLE_LINE_HEIGHT_MAP,
    UPLOAD_URL_MAP
};
